import { type WalletLedgerRemainingLimit } from '@capsicum/common';
import { useMainCurrenciesQuery } from '@capsicum/socios-core';
import { type QueryOptions, useQuery } from '@tanstack/react-query';

import { fetchLimitLedgerRemaining } from '../api';

/**
 *
 * @param fanTokenCurrencyId
 * @returns ledger limits
 */

export const useLedgerRemainingLimitQuery = <TData = undefined | WalletLedgerRemainingLimit>(
	select: (data: undefined | WalletLedgerRemainingLimit) => TData,
	fanTokenCurrencyId?: string,
	options?: QueryOptions
) => {
	const { data: currencies, error: currenciesQueryError, isLoading: isLoadingCurrencies } = useMainCurrenciesQuery();

	if (currenciesQueryError) throw currenciesQueryError;

	const { convertAmountToCurrencies } = currencies ?? {};

	const { defaultCurrency } = currencies ?? {};

	const currencyId = fanTokenCurrencyId || defaultCurrency?.id;

	const queryResult = useQuery({
		enabled: Boolean(convertAmountToCurrencies?.length),
		queryFn: () =>
			fetchLimitLedgerRemaining({
				batchType: 'buy',
				'convertAmountToCurrencies[]': convertAmountToCurrencies,
				currencyId: currencyId,
				movementType: 'credit'
			}),
		queryKey: ['ledgerRemainingLimit', currencyId, convertAmountToCurrencies],
		select: select as (data: unknown | WalletLedgerRemainingLimit) => TData,
		...options
	});

	return {
		...queryResult,
		isLoading: queryResult.isLoading || isLoadingCurrencies
	};
};
